import axios from '@/requests';
import {
    FileConstructionNode,
    FileConstructionPagination,
    FileDownloadLink,
    FileConstructionDigest,
} from '@/store/modules/fileConstruction/types';
import { DefaultPagination } from '@/store/modules/fileConstruction';

export interface FileConstructionNodeResp {
    nodes: FileConstructionNode[],
    digest: FileConstructionDigest,
}

export interface GetFileConstructionByPathReq extends FileConstructionPagination {
    projId: string,
    path: string,
    uid: string,
}

export interface GetFileConstructionByUidReq extends FileConstructionPagination {
    projId: string,
    pid: number,
    uid: string,
}

export interface GetFileNodeByPathReq {
    projId: string,
    path: string,
    uid: string,
}

export interface GetFileBySearch extends FileConstructionPagination {
    projId: string,
    fileName: string,
    uid: string,
}

export interface GetFileByExtension extends FileConstructionPagination {
    projId: string,
    uid: string,
    extension: string,
}

export interface GetFileByStatusReq extends FileConstructionPagination {
    projId: string,
    uid: string,
    status: string,
}

export interface NodeIdReq {
    projId: string,
    nodeId: number,
    uid: string,
}

export interface GetUserNameReq {
    projId: string,
    uid: string,
}

export interface CommonDirEntity {
    name: string,
    dirStr: string,
}

export const CommonDirMap = [
    {
        name: "桌面",
        dirStr: "C:/Users/USERNAME/Desktop/",
    },
    {
        name: "文档",
        dirStr: "C:/Users/USERNAME/Documents/",
    },
    {
        name: "下载",
        dirStr: "C:/Users/USERNAME/Downloads/",
    },
    {
        name: "Tg下载",
        dirStr: "C:/Users/USERNAME/Downloads/Telegram Desktop/",
    },
];
export const ExtraDirMap = [
    {
        name: "已上传"
    },
    {
        name: "可下载"
    },
    {
        name: "Office文档",
        children: [
            {
                name: "DOC文档",
            },
            {
                name: "PPT演示文稿",
            },
            {
                name: "EXCEL表格",
            },

        ]
    },
    {
        name: "文本文档",
    },
    {
        name: "PDF文档",
    },
    {
        name: "图片",
    },
]


const initializeNode = (rawRes: FileConstructionNode[]): FileConstructionNode[] => {
    return rawRes.map((node: FileConstructionNode) => {
        node.isDummy = true;
        node.children = [];
        node.pagination = { ...DefaultPagination };
        node.isAllLoaded = false;
        return node;
    });
}

export const fileConstructionAPI = {
    async getUserNameByProjIdAndUid(req: GetUserNameReq): Promise<string> {
        try {
            return await axios.get<string>('/File/getUserNameByProjIdAndUid', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async getChildrenByPath(req: GetFileConstructionByPathReq): Promise<FileConstructionNodeResp> {
        try {
            const rawRes = await axios.get<FileConstructionNodeResp>(
                '/File/findChildrenByPath',
                req,
            );
            return { ...rawRes, nodes: initializeNode(rawRes.nodes) };

        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getChildrenByParentId(req: GetFileConstructionByUidReq): Promise<FileConstructionNodeResp> {
        try {
            const rawRes = await axios.get<FileConstructionNodeResp>(
                '/File/findChildrenByPid',
                req,
            );
            return { ...rawRes, nodes: initializeNode(rawRes.nodes) };
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getNodeByPath(req: GetFileNodeByPathReq): Promise<FileConstructionNode> {
        try {
            return await axios.get<FileConstructionNode>('/File/findNodeByPath', req);

        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getSearchResult(req: GetFileBySearch): Promise<FileConstructionNodeResp> {
        try {
            return await axios.get<FileConstructionNodeResp>('File/fuzzySearchFileName', req)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getMegaDownloadLink(req: NodeIdReq): Promise<null> {
        try {
            await axios.get<FileDownloadLink>("mega/getDownloadLinkByNodeId", req)
            return null
        } catch (err) {
            return Promise.reject(err)
        }
    },
    async getFileListByDownloadStatus(req: GetFileByStatusReq): Promise<FileConstructionNodeResp> {
        try {
            return await axios.get<FileConstructionNodeResp>('/File/getFileListByDownloadStatus', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDiskByProjIdAndUid(req: GetUserNameReq): Promise<FileConstructionNode[]> {
        try {
            return await axios.get<FileConstructionNode[]>('/File/getDiskSlice', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDigestById(req: { projId: string, uid: string, pid: number }): Promise<FileConstructionDigest> {
        try {
            return await axios.get<FileConstructionDigest>('/File/getDigestById', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDigestByFuzzySearch(
        req: {
            projId: string,
            uid: string,
            pathRegEx: string,
        }): Promise<FileConstructionDigest> {
        try {
            return await axios.get<FileConstructionDigest>('/File/getDigestByNameReg', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDigestByFileStatus(
        req: {
            projId: string,
            uid: string,
            status: string,
        }): Promise<FileConstructionDigest> {
        try {
            return await axios.get<FileConstructionDigest>('/File/getDigestByFileStatus', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDigestByExtension(
        req: {
            projId: string,
            uid: string,
            extension: string,
        }): Promise<FileConstructionDigest> {
        try {
            return await axios.get<FileConstructionDigest>('/File/getDigestByExtension', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDigestByPath(req: { projId: string, uid: string, path: string }): Promise<FileConstructionDigest> {
        try {
            return await axios.get<FileConstructionDigest>('/File/getDigestByPath', req);
        } catch (err) {
            return Promise.reject(err);
        }
    },
}

